const _ = require('./enum');
module.exports = {
  [_.PRODUCT_NOT_AVAILABLE]: { id: _.PRODUCT_NOT_AVAILABLE, label: 'Product not available' },
  [_.REQUESTED_BY_CUSTOMER]: { id: _.REQUESTED_BY_CUSTOMER, label: 'Requested by customer' },
  [_.FRAUDULENT]: { id: _.FRAUDULENT, label: 'Fraudulent' },
  [_.DUPLICATE]: { id: _.DUPLICATE, label: 'Duplicate' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
